import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { includes } from "lodash";
import slug from "slug";

/**
 *
 * @param page
 * @param url_slugs
 * @param body
 * @param props
 * @returns {{component: string, id: string, props: (*&{containerClassName: string, body: (*|null), ctas: null})}}
 */
export const body = ({ page, url_slugs, body, ...props }) => {
  let ctas = [];

  if (!page && !body) {
    return null;
  }

  if (url_slugs && url_slugs.includes("find-a-job") && (!url_slugs.includes("clinical-assessor-jobs"))) {
    const [_, url_slug] = url_slugs.reverse();
    const routePage = simple_pages_helper.find(url_slug);

    if (
      routePage &&
      (("related_division" in routePage && routePage["related_division"]) ||
        ("related_sector" in routePage && routePage["related_sector"]))
    ) {
      ctas = [
        ...ctas,
        {
          label: `Browse and apply for ${routePage.title}`,
          href: `/jobs/#/${slug(routePage.related_division ?? routePage.related_sector)}`,
          variant: "secondary",
        },
      ];
    }
  }

  if (Array.isArray(page.buttons)) {
    ctas = [
      ...ctas,
      ...page.buttons
        .filter((i) => !!i.link)
        .map((i) => ({
          label: i.label ?? "Read more",
          href: i.link ?? "#",
          variant: i.variant ?? "secondary",
        })),
    ];
  }

  return {
    component: "RichText",
    id: "Body",
    props: {
      containerClassName: "mw-xxl",
      body: body ?? page["body"] ?? null,
      ctas,
      ...props,
    },
  };
};
